import {
    GET_APPLICATION_STATUS_DEF_SUCCESS,
    API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
  }
  
  const applicationStatus = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_APPLICATION_STATUS_DEF_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
        }
      case API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
        return state
  
    }
  }
  
  export default applicationStatus